import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import RoleBasedSource from "./From/RoleBasedSource";
import DateTimeInput from "../../../form/DateTimeInput";
import NewDefault from "./Buttons/NewDefault";
import Target from "./To/Target";
import {connect} from "src/store";
import Box from "../../../layout/Box";
import TillBasedPos from "./Pos/TillBasedPos";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import {
    DateFormatter,
    optionsTemplate,
    ProductColumn,
    ProductSelect,
    UnitFormatter
} from "../../../../utils/formatters";
import TabContent from "../../../layout/TabContent";
import Tabs from "../../../layout/Tabs";
import TextInput from "../../../form/TextInput";
import {ifCompletedInput} from "../../../../utils/other";
import Select from "../../../form/Select";
import FragmentEditor from "../../FragmentEditor";

const sortable = true;
const filterable = true;

let items = null;

export default connect((state) => {
    return {
        till: state.app.till
    };
}, {})((componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons, pool} = props;
    const Editor = props.editor || FragmentEditor;
    const to = (componentProps.props.period || {}).to;
    const from = (componentProps.props.period || {}).from;

    const buttons = <div className="modal-footer with-footer">
        <Fragment>
            {props.values.id ? actionButtons : null}
            <NewDefault {...componentProps} />
        </Fragment>
    </div>;

    if (
        !(componentProps.till && componentProps.till.pos && componentProps.till.pos.location && componentProps.till.pos.location.store && componentProps.till.pos.location.store.id + "" === "" + componentProps.till.pos.location.store.store)
    ) {
        return <Box header="Hiba" theme="danger">
            "Virtuális" helyen nem lehet pótlást leadni!
        </Box>;
    }

    const columns = {...pool.columns};
    delete columns['outgoing'];
    delete columns['instore'];
    delete columns['base_instore'];
    delete columns['inwarehouse'];
    delete columns['intransitqty'];
    columns['qty'] = columns['pickedqty'];
    delete columns['pickedqty'];
    return <Editor
        theme="default"
    >
        <form onSubmit={props.handleSubmit} className="ShopSupplement">
            <div className="row form-row hidden">
                <TillBasedPos {...componentProps} />
            </div>
            <Tabs
                defaultTab="list"
                theme="default"
                className="modal-tabs"
            >
                <TabContent
                    tabLabel="Lista"
                    tabName="list"
                >
                    <div className="row form-row">
                        <div className="col-md-3">
                            <Target {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, target: "Bolt"}}}} disabled={true} />
                        </div>
                        <div className="col-md-3">
                            <DateTimeInput maxDate={to} value={from} label="Időszak" saveChanges={ (field, value) => componentProps.setState({period: {...componentProps.props.period, from: value}}) }/>
                        </div>
                        <div className="col-md-3">
                            <DateTimeInput minDate={from} value={to} label="&nbsp;" saveChanges={ (field, value) => componentProps.setState({period: {...componentProps.props.period, to: value}}) }/>
                        </div>
                        <div className="col-md-3">
                            <RoleBasedSource {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, source: "Raktár/Bolt"}}}} />
                        </div>
                    </div>
                    {props.values.source && <PoolList {...componentProps} control={{visible: false}} onSourceItemUpdate={componentProps.onSourceItemUpdate} />}
                    {buttons}
                </TabContent>
                <TabContent
                    tabLabel="Kiválasztottak"
                    tabName="selected"
                >
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Target {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, target: "Bolt"}}}} disabled={true} />
                        </div>
                        <div className="col-md-6">
                            <RoleBasedSource {...{...componentProps, props: {...componentProps.props, labels: {...componentProps.props.labels, source: "Raktár/Bolt"}}}} />
                        </div>
                    </div>
                    <SelectorGrid
                        ref={(grid) => items = grid}
                        name="items"
                        componentConfig={props.componentConfig}
                        data={props.values}
                        parentid={props.values[props.componentConfig.idfield]}
                        columns={columns}
                        view={[...pool.view, "qty"]}
                        sortBy={[{field: "created_at", direction: "DESC"}]}
                        addRow={<Select
                            storeType="remote"
                            component="Product"
                            placeholder="Termék hozzáadás"
                            objectValue={true}
                            order={{field: "id", direction: "desc"}}
                            view={[...ProductSelect.view, "vat.rate", "qty"]}
                            optionsTemplate={optionsTemplate("product")}
                            label={false}
                            openIfHasOptions={true}
                            saveChanges={async (field, product) => {
                                product.product_id = product.id;
                                product.component_id = product.id;
                                product.component_type = "product";
                                delete product.id;
                                await componentProps.onSourceItemUpdate(product, JSON.parse(JSON.stringify({component_id: 0, ...product})));
                                items && items.refresh();
                            }}
                        />}
                        onItemUpdate={async (item, oldItem, field, action) => {
                            return await componentProps.onSourceItemUpdate(item, oldItem, field, action);
                        }}
                    />
                    {buttons}
                </TabContent>
            </Tabs>
        </form>
    </Editor>;
});